import { ScreenEnum, useScreen } from 'feature/screenMode'
import { MouseDraggableArea } from 'widget/MouseDraggableArea/MouseDraggableArea'

import style from './HowWork.module.scss'
import { HowWorkList } from './HowWorkList'
import { HowWorkMobileSlider } from './HowWorkMobileSlider'

type HowWorkType = {
  className?: string
}

// блок "как это работает?"
export function HowWork({ className }: HowWorkType) {
  const screen = useScreen()

  return (
    <div className={className}>
      <p className='h1'>Заказать изделие DoorHan за 5 простых шагов</p>

      <MouseDraggableArea>
        <div className={style.cardWrap}>
          {screen === ScreenEnum.mobile ? (
            <HowWorkMobileSlider />
          ) : (
            <HowWorkList />
          )}
        </div>
      </MouseDraggableArea>
    </div>
  )
}
